interface FetchDataOptions {
  params?: Record<string, any>
  body?: Record<string, any>
  method?: 'GET' | 'POST' | 'PUT' | 'DELETE'
  authentication?: boolean
  // biome-ignore lint/suspicious/noExplicitAny: <explanation>
  query?: Record<string, any>
}

// file://../../backend/v2/src/api/cart/cart.handler.ts
const funcApiUrl = {
  clearCart: {
    method: 'POST',
    url: '/api/v2/cart/clear',
  },
  updateCart: {
    method: 'POST',
    url: '/api/v2/cart/update',
  },
  deleteCartItem: {
    method: 'POST',
    url: '/api/v2/cart/delete',
  },
  cartSetOutlet: {
    method: 'POST',
    url: '/api/v2/cart/setOutlet',
  },
  useOffer: {
    method: 'POST',
    url: '/api/v2/cart/useOffer',
  },
  useOfferById: {
    method: 'POST',
    url: '/api/v2/cart/useOfferById',
  },
  payViaEghl: {
    method: 'POST',
    url: '/api/v2/cart/payViaEghl',
  },
  cartShippingAddress: {
    method: 'POST',
    url: '/api/v2/cart/setShippingAddress/:sessionToken',
  },
  cartBillingAddress: {
    method: 'POST',
    url: '/api/v2/cart/setBillingAddress/:sessionToken',
  },
  setCartCarrier: {
    method: 'POST',
    url: '/api/v2/cart/setCarrier',
  },
  getWallets: {
    method: 'GET',
    url: '/api/v2/wallets/getWallets/:userId',
  },
  userWalletAdd: {
    method: 'POST',
    url: '/api/v2/wallets/userWalletAdd',
  },
  userOffer: {
    method: 'POST',
    url: '/api/v2/offer/userOffer',
  },
  signup: {
    method: 'POST',
    url: '/api/v2/users/signup',
  },
  requestResetPassword: {
    method: 'POST',
    url: '/api/v2/users/requestResetPassword',
  },
  resetPassword: {
    method: 'POST',
    url: '/api/v2/users/resetPassword',
  },
  finalizeSignup: {
    method: 'POST',
    url: '/api/v2/user/finalizeSignup',
  },
  purchaseOffer: {
    method: 'POST',
    url: '/api/v2/offers/purchaseOffer',
  },
  cartPaymentMethod: {
    method: 'POST',
    url: '/api/v2/cart/setPaymentMethod',
  },
  fetchStates: {
    method: 'POST',
    url: '/api/v2/states',
  },
  checkout: {
    method: 'POST',
    url: '/api/v2/cart/checkout',
  },
  s3Upload: {
    method: 'POST',
    url: '/api/v2/s3/upload',
  },
  
}

export async function callFuncWithParams(
  func: string,
  params: Record<string, any>,
  data?: Record<string, any>,
  options?: FetchDataOptions,
) {
  return callFunc(func, data, {
    ...options,
    body: data,
    params: params || {},
  })
}

export async function callFunc(
  func: string,
  data?: Record<string, any>,
  options?: FetchDataOptions,
) {
  const f = funcApiUrl[func]
  if (!f) {
    throw new Error(`Invalid function name: ${func}`)
  }
  console.log('callFunc', { func, f, data })
  if (f.method === 'GET') {
    return fetchData(f.url, {
      ...options,
      params: data,
      method: f.method,
      query: options?.query || data,
    })
  }
  // console.log('posting', { body: data })
  return fetchData(f.url, {
    ...options,
    body: data,
    params: options?.params,
    method: f.method,
    query: options?.query || {},
  })
}

export async function fetchData(
  uri: string,
  options: FetchDataOptions = {
    params: {},
    method: 'GET',
    authentication: true,
    query: {},
    body: {},
  },
) {
  const { v2ApiBase } = useApiBase()
  const $acl = useAclStore()
  const method = options.method || 'GET'
  const hasBody = method === 'POST' || method === 'PUT' || method === 'DELETE'

  const uriWithParams = (() => {
    const res = uri.match(/:([^/]+)/g)?.reduce((acc, param) => {
    const paramName = param.substring(1) // Remove the : prefix
    const paramValue = options.params?.[paramName] || ''
    // console.log('fetchData', { paramName, paramValue, params: options.params })
    return acc.replace(param, encodeURIComponent(paramValue))
  }, uri) || uri

    if (res.endsWith('/')) {
      return res.slice(0, -1)
    }
    return res
  })()
  console.log('fetchData', { uri, paramsKeys: Object.keys(options?.params || {}), uriWithParams, options })

  const response = await fetch(`${v2ApiBase}${uriWithParams}`, {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...(options?.authentication === false
        ? {}
        : { Authorization: `Bearer ${$acl.currentUser?.accessToken}` }),
    },
    ...(hasBody && (options?.body || options?.params)
      ? { body: JSON.stringify(options.body || options.params) }
      : {}),
  })

  if (!response.ok) {
    const data = await response.json()
    console.log('fetchData error', { status: response.status, data })
    if (data.error) {
      throw new Error(data.error)
    }
    if (data.message) {
      throw new Error(data.message)
    }
    throw new Error(`HTTP error! status: ${response.status}`)
  }
  const data = await response.json()
  return data
}
